import { css, Global } from '@emotion/react'
import { useTheme } from '@mui/material/styles'

const makeGlobalStyles = () => css`
  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ol,
  ul {
    margin: 0;
    padding: 0;
    font-family: 'Avenir Next LT Pro', Arial, Helvetica, sans-serif;
  }

  ol,
  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
    background: transparent;
    border: none;
  }

  button:disabled {
    cursor: not-allowed;
  }
`

const GlobalStyles = () => {
  const theme = useTheme()
  return <Global styles={makeGlobalStyles(theme)} />
}

export default GlobalStyles
